import { render, staticRenderFns } from "./RoundedButton.vue?vue&type=template&id=5f6e8799&scoped=true&"
import script from "./RoundedButton.vue?vue&type=script&lang=ts&"
export * from "./RoundedButton.vue?vue&type=script&lang=ts&"
import style0 from "./RoundedButton.vue?vue&type=style&index=0&id=5f6e8799&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e8799",
  null
  
)

export default component.exports